// extracted by mini-css-extract-plugin
export default {"wrapper":"Text_wrapper__u1xjF"};